import {
  Button,
  Dialog,
  DialogContent,
  Stack,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { useMutation, useQueryClient } from "react-query";
import { addUpdateDraftOrder } from "src/pages/api";

export default function ApproveDeleteDraft({ onClose, actionType, row }) {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const mutation = useMutation(req => addUpdateDraftOrder({ req }), {
    onSuccess: () => {
      enqueueSnackbar(
        `Draft ${actionType === "delete" ? "deleted" : "updated"} successfully`,
        {
          variant: "success",
        }
      );
      queryClient.invalidateQueries(["draftOrder"]);

      onClose();
    },
    onError: error => {
      enqueueSnackbar(
        error?.message ||
          `Failed to ${actionType === "delete" ? "deleted" : "updated"}`,
        {
          variant: "error",
        }
      );
    },
  });
  const handleDelete = async () => {
    try {
      const req = {
        draftOrderID: row.purchaseOrderID,
        schoolID: row.schoolID,
        orderStatus: actionType === "delete" ? 0 : 2,
      };
      mutation.mutate(req);
    } catch (error) {
      // console.log(error);
    }
  };
  return (
    <Dialog open>
      <DialogContent>
        <Typography variant="subtitle1">
          {" "}
          Are you Sure. You want to&nbsp;
          {actionType === "delete" ? "deleted" : "approved"} this record
        </Typography>
        <Stack direction={"row"} justifyContent={"center"} gap={2} mt={2}>
          <Button variant="contained" color="primary" onClick={handleDelete}>
            Yes
          </Button>
          <Button variant="contained" color="error" onClick={onClose}>
            No
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
